import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { filter, take } from 'rxjs'
import { loadScreenConfigsByCompanyGroup } from 'src/app/store/action/onboarding.action'
import { getCompany } from 'src/app/store/selector/onboarding.selector'

@Component({
  selector: 'app-main-screen-config',
  templateUrl: './main-screen-config.component.html',
  styleUrls: ['./main-screen-config.component.scss']
})
export class MainScreenConfigComponent implements OnInit {
  constructor(private store: Store) {}

  activeTab: 'employee' | 'admin' | 'form11' = 'employee'

  ngOnInit(): void {
    this.store
      .select(getCompany)
      .pipe(
        filter(company => !!company),
        take(1)
      )
      .subscribe(company => {
        const companyGroupId = company.id
        this.store.dispatch(
          loadScreenConfigsByCompanyGroup({
            companyGroupId
          })
        )
      })
  }

  setTab(tab: 'employee' | 'admin' | 'form11') {
    this.activeTab = tab
  }

  goToNextTab() {
    if (this.activeTab === 'employee') {
      this.activeTab = 'admin'
    } else if (this.activeTab === 'admin') {
      this.activeTab = 'form11'
    }
  }
}
